import { translate } from "@kaltura/mediaspace-shared-utils";
import { CreatePlaylistModal, CreatePlaylistFormProps } from "@kaltura/mediaspace-shared-create-playlist-modal";
import { MenuItem, MenuItemProps } from "@kaltura/ds-react-components";
import { useContext, useState } from "react";
import { Playlist24Icon } from "@kaltura/ds-react-icons";
import styled from "@emotion/styled";
import { useToastsContext } from "@kaltura/mediaspace-shared-contexts/ToastsContext";
import { ConfigContext } from "@kaltura/mediaspace-shared-data-kms-config/ConfigContext";

/**
 * Props for CreateChannelPlaylistMenuItem
 * Extends MenuItemProps to allow passing through standard MenuItem a11y props.
 */
type CreateChannelPlaylistMenuItemProps = Pick<CreatePlaylistFormProps, "submitUrl" | "channelId"> & MenuItemProps;

/**
 * menu item which opens a channel playlist creation modal
 */
export const CreateChannelPlaylistMenuItem = (props: CreateChannelPlaylistMenuItemProps) => {
    const { submitUrl, channelId, onClick, ...rest } = props;
    const [openModal, setOpenModal] = useState(false);

    const { showToast } = useToastsContext();

    const handlePlaylistCreated = (createdPlaylistId: string, createdPlaylistName: string) => {
        showToast({ severity: "success", message: translate("Playlist “%1” was created", [createdPlaylistName]) });
        setOpenModal(false);
    };

    const configContext = useContext(ConfigContext);
    const isKaf = configContext.application?.isKAF;

    return (
        <>
            <MenuItem onClick={() => setOpenModal(true)} {...rest}>
                <StyledMenuItem>
                    <Playlist24Icon />
                    {isKaf ? translate("Create media gallery playlist") : translate("Create channel playlist")}
                </StyledMenuItem>
            </MenuItem>

            <CreatePlaylistModal
                open={openModal}
                onCancel={() => setOpenModal(false)}
                submitUrl={submitUrl}
                channelId={channelId}
                onCreate={handlePlaylistCreated}
            />
        </>
    );
};

const StyledMenuItem = styled("span")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.3),
}));
